/* Spotlight Portfolio — poster gallery. Oversized images with cinema
   marquee captions. Black canvas, champagne accent. Each plate a
   "feature presentation". */

import { useEffect } from "react";
import { useSiteSettings } from "@/hooks/useSiteSettings";
import { getFocalStyle } from "@/lib/focal";
import { optimizeImageUrl } from "@/lib/imageOptim";
import { EditorialSkeleton } from "../editorial/_EditorialSkeleton";

export default function SpotlightPortfolio() {
  const { settings, loading } = useSiteSettings();
  const port = settings?.portfolio_images || [];
  const focals = settings?.portfolio_focal_points || [];
  const studioName = settings?.studio_name || "Studio";
  useEffect(() => { document.title = `${studioName} — Past Features`; }, [studioName]);
  if (loading && !settings) return <EditorialSkeleton eyebrow="Curtain up." />;

  return (
    <div data-testid="spotlight-portfolio" style={{ background: "var(--tenant-bg, #0A0A0F)", color: "var(--tenant-fg, #F5E9C9)" }}>

      <section className="px-6 lg:px-16 pt-20 pb-12 text-center border-b" style={{ borderColor: "color-mix(in srgb, var(--tenant-accent) 35%, transparent)" }}>
        <div className="text-[10px] uppercase tracking-[0.5em] mb-5" style={{ color: "var(--tenant-accent)" }}>
          ✦ Past Features
        </div>
        <h1 className="uppercase leading-[0.95]" style={{ fontFamily: "var(--tenant-serif)", fontSize: "clamp(2.5rem, 7vw, 5.5rem)" }}>
          {settings?.portfolio_title || "The Reel."}
        </h1>
      </section>

      <div className="max-w-[1280px] mx-auto px-6 lg:px-16 py-20 space-y-20">
        {port.map((src, i) => (
          <figure key={i}
            className={`grid md:grid-cols-12 gap-8 items-center ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}>
            <div className="md:col-span-8 md:[direction:ltr]">
              <img src={optimizeImageUrl(src, { w: 1600 })} alt=""
                className="w-full aspect-[4/3] object-cover"
                style={getFocalStyle(focals, i)}
                loading={i < 2 ? "eager" : "lazy"} decoding="async" />
            </div>
            <figcaption className="md:col-span-4 md:[direction:ltr] text-center md:text-left">
              <div className="text-[10px] uppercase tracking-[0.5em] mb-3" style={{ color: "var(--tenant-accent)" }}>
                ✦ Feature №{String(i + 1).padStart(2, "0")}
              </div>
              <div className="text-2xl uppercase leading-tight mb-2" style={{ fontFamily: "var(--tenant-serif)" }}>
                {studioName} · {new Date().getFullYear() - Math.floor(i / 3)}
              </div>
              <div className="text-[10px] uppercase tracking-[0.42em]" style={{ color: "color-mix(in srgb, var(--tenant-fg) 60%, transparent)" }}>
                A {studioName} Picture · 35mm
              </div>
            </figcaption>
          </figure>
        ))}
        {port.length === 0 && (
          <p className="text-center text-[10px] uppercase tracking-[0.5em]" style={{ color: "var(--tenant-fg-soft)" }}>
            ✦ Coming attractions
          </p>
        )}
      </div>
    </div>
  );
}
